import React , {useEffect} from "react";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import SvgIconStyle from "../../../components/SvgIconStyle";
import DonationDetail from "./DonationDetail";
import { ComponentType ,DonationStatus} from "../../../common/enum";
import DonationDrawer from "../DonationDrawer";
import MessagePanel from "../../MessagePanel";
import { db } from "../../../firebase";
import {
query,
where,
getCountFromServer,
collection as firebaseCollection,
getDocs,
onSnapshot,
collectionGroup,
} from "firebase/firestore";
var allDOnations = []
var mensagensEntidades = []
const DonationCard = ({all, item,messagens, donationStatus, donationFilter, t }) => {
  
  const {
   auth,
   dashboardInfo: { entityProfileSelect },
 } = useSelector((state) => state);
 const { entity, userType, userId } = auth.profile || {};
  const [drawerState, setDrawerState] = React.useState(false);
  const [anchorMessageDrawer, setAnchorMessageDrawer] = React.useState(null);
  const [messsageUnreadCount, setMessageUnReadCount] = React.useState(null);
  const [ItemValue, setItemValue] = React.useState(null);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  let currentTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
 
  const [messageUserCount, setMessageUserCount] = React.useState(0);
  const [value, setValue] = React.useState(0);
  const [entities, setEntities] = React.useState([]);
  const [mensagens, setMensagens] = React.useState([]);
  const {
    auth: { profile },
  } = useSelector((state) => state);

  var donationId;
  var donationEntityId;
  
  

  donationcardgrid();

  async function donationcardgrid() {
   
    // // Use a Promise to wait for all queries to complete
    // const queryPromises = [];

    // for (let index = 0; index < all.length; index++) {
    //   const donationId = all[index].donation?.donationId;
  
    //   if (donationId) {
    //     const q = query(
    //       firebaseCollection(db, "entityChats", profile?.userId, "entityInfo"),
    //       where("donationId", "==", donationId)
    //     );
  
    //     const queryPromise = new Promise((resolve, reject) => {
    //       const unsub = onSnapshot(q, (snap) => {
    //         const arr = [];
    //         snap.forEach((doc) => {
    //           arr.push(doc.data());
    //         });
    //         setEntities([...arr]);
    //         console.log([...arr], 'setEntities([...arr]);');
    //         mensagensEntidades.push({ "Mensagens": arr.length, "indexDonation": index, "donationId": donationId });
    //         // Resolve the Promise when the query is done
    //         resolve();
    //       });
    //     });
  
    //     queryPromises.push(queryPromise);
    //   }
    // }
  
    // Wait for all queries to complete before processing allDOnations
    // await Promise.all(queryPromises);
   allDOnations = [];
const processedDonations = all.map((item) => {
  const donationId = item.donation?.donationId;
  const hasMessages = messagens.some(entry => entry.donationId === donationId);

  allDOnations.push({
    mensagens: hasMessages ? "tem" : "naoTem",
    dataInicioCanalAlternativo: item.donation?.consumeByDate
      ? new Date(item.donation?.expiryDate).toLocaleString("pt-PT", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          formatMatcher: "best fit",
          timeZone: currentTimeZone,
        })
      : "n/d",
    dataFinalCanalAlternativo: item.donation?.consumeByDate
      ? new Date(item.donation?.consumeByDate).toLocaleString("pt-PT", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          formatMatcher: "best fit",
          timeZone: currentTimeZone,
        })
      : "n/d",
    isAnimal: item.donation.isAnimal,
    status:
      item.donation.status === "RESERVED"
        ? "Reserva Total"
        : item.donation.status === "PARTIAL"
        ? "Reserva Parcial"
        : "n/d",
    id2: item.donation.id,
    id: `${new Date(item.donation.createdDate).getFullYear()}${item.donation.id}`,
    donationType: item.donation.isEvent ? t("event") : t("donations"),
    dataFim: new Date(item.donation?.expiryDate).toLocaleString("pt-PT", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      formatMatcher: "best fit",
      timeZone: currentTimeZone,
    }),
    dataInicio: new Date(item?.donation?.availableFromDate).toLocaleString("pt-PT", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      formatMatcher: "best fit",
      timeZone: currentTimeZone,
    }),
    reserva: item.collectionCount,
  });
});
    // Now, processedDonations contains the updated data for allDOnations.
   // console.log(processedDonations);
    
  }

  // function donationcardgrid(){
  //   allDOnations = []
  //   mensagensEntidades =[]
  //  for (let index = 0; index < all.length; index++) {
  //     donationId = all[index].donation?.donationId
  //     donationEntityId = all[index].donation?.entityId
      
      
  //         let q;
  //         if (donationId) {
  //           q = query(
  //             firebaseCollection(db, "entityChats", profile?.userId, "entityInfo"),
  //             where("donationId", "==", donationId),
  //           );
  //         }
  //         const unsub = onSnapshot(q, (snap) => {
  //           const arr = [];
  //           snap.forEach((doc) => {
  //             arr.push(doc.data());
  //           });
  //           setEntities([...arr]);
  //           console.log([...arr] , 'setEntities([...arr]);')
  //           mensagensEntidades.push({"Mensagens" : [...arr].length , "indexDonation" : index , "donationId": donationId})
  //         });
         
       
     

  //     allDOnations.push ({ 
  //                       mensagens: String(mensagensEntidades.filter((item) => item.donationId === all[index].donation?.donationId && item.Mensagens > 0).length > 0 ? "tem" : "naoTem") ,
  //                       //mensagens : mensagensEntidades && mensagensEntidades.length > 0 && mensagensEntidades[index].Mensagens,
  //                       dataFinalCanalAlternativo : `${new Date(
  //                         all[index].donation?.consumeByDate + "Z"
  //                       ).toLocaleString("pt-PT", {
  //                         day: "numeric",
  //                         month: "numeric",
  //                         year: "numeric",
  //                         hour: "numeric",
  //                         minute: "numeric",
  //                         formatMatcher: "best fit",
  //                         timeZone: currentTimeZone,
  //                       })}`,
  //                       isAnimal:all[index].donation.isAnimal,
  //                       status:all[index].donation.status == 'RESERVED' ? 'Reserva Total' : all[index].donation.status == 'PARTIAL' ?  'Reserva Parcial' : '',
  //                       id2:all[index].donation.id,
  //                       id:`${new Date(all[index].donation.createdDate).getFullYear()}${all[index].donation.id}` ,  
  //                       donationType: all[index].donation.isEvent ? t("event") : t("donations") ,
  //                       dataFim:`${new Date(
  //                         all[index].donation?.expiryDate + "Z"
  //                       ).toLocaleString("pt-PT", {
  //                         day: "numeric",
  //                         month: "numeric",
  //                         year: "numeric",
  //                         hour: "numeric",
  //                         minute: "numeric",
  //                         formatMatcher: "best fit",
  //                         timeZone: currentTimeZone,
  //                       })}`,
  //                       dataInicio:`${new Date(
  //                         all[index]?.donation?.availableFromDate + "Z"
  //                       ).toLocaleString("pt-PT", {
  //                         day: "numeric",
  //                         month: "numeric",
  //                         year: "numeric",
  //                         hour: "numeric",
  //                         minute: "numeric",
  //                         formatMatcher: "best fit",
  //                         timeZone: currentTimeZone,
  //                       })} `,
  //                       reserva:all[index].collectionCount
  //                     });
  //  }
  // }
  

  const toggleDrawer = React.useCallback((value) => {
    setDrawerState(value);
  }, []);

  const handleClick = React.useCallback((value) => {
    var itemteste = all.filter(product => product.donation.id === value.id2)
    setItemValue(itemteste)
    setDrawerState(true);
  }, []);

  const handleMessageClick = (event , value) => {
    var itemteste = all.filter(product => product.donation.id === value.id2)
    setItemValue(itemteste)
    setAnchorMessageDrawer(event.currentTarget);
  };

  const toggleMessageDrawer = React.useCallback((value) => {
    setAnchorMessageDrawer(value);
  }, []);

  return (
    <>
      <Paper
        variant="outlined"
       
        sx={{
          p: 2,
          width: 1,
          flexGrow: 1,
          backgroundColor: "#fff",
        }}
        elevation={0}
      >
        <DonationDetail
              all = {allDOnations}
              componentType={ComponentType.DONATION_CARD}
              t={t}
              handleClick = {handleClick}
              handleMessageClick = {handleMessageClick}
              donationStatus={donationStatus}
            />
        {/* <Grid
            item
            xs={10}
            sx={{ display: "flex", flexDirection: matches ? "column" : "row" }}
          >
            
          </Grid> */}
        {/* <Grid container spacing={1} alignItems={"center"}>
          
          <Grid
            item
            xs={2}
            sx={{
              display: "flex", justifyContent: "flex-end",
              '@media (max-width:700px)': {
                flexDirection: "column"
              }
            }}
            fontFamily={"Poppins"}
          >
            {item.collectionCount > 0 && (
              <Button
                sx={{
                  mr: 1,
                  width: "36px",
                  height: "36px",
                  minWidth: 0,
                  borderRadius:'4px'
                }}
                onClick={handleMessageClick}
              >
                <MessageOutlinedIcon />
              </Button>
            )}
            <Button
              sx={{
                bgcolor: "#E1EFB0",
                width: "36px",
                height: "36px",
                minWidth: 0,
                borderRadius:'4px'
              }}
              size="small"
              onClick={handleClick}
            >
              <SvgIconStyle
                src="/static/dashboard/info.svg"
                sx={{ color: "black", width: "16px", height: "16px" }}
              />
            </Button>
          </Grid>
        </Grid> */}
      </Paper>
      {ItemValue &&<DonationDrawer
        drawerState={drawerState}
        toggleDrawer={toggleDrawer}
        donationDetail={ItemValue[0]}
        donationStatus={donationStatus}
        donationFilter={donationFilter}
        component={ComponentType.DONATION}
        t={t}
      />}
        {ItemValue &&<MessagePanel
        drawerState={anchorMessageDrawer}
        setMessageUnReadCount={setMessageUnReadCount}
        toggleDrawer={toggleMessageDrawer}
        donationEntityId={ItemValue[0].donation.entityId}
        donationId={ItemValue[0].donation.donationId}
        t={t}
      />}
    </>
  );
};

export default DonationCard;
